import {
  Component,
  OnInit,
  Input,
  SimpleChanges,
  Output,
  EventEmitter,
} from '@angular/core';
import { ActivityCard } from '../../../../interfaces/activity-card.interface';
import { ApiV2Service } from '../../../../services/api-v2.service';
import { Scene } from '../../../../models/scene.model';
import { Router } from '@angular/router';
import { SpinnerService } from '../../../../services/spinner.service';
import { AuthService } from '../../../../services/auth.service';
import { MessagesModalService } from '../../../../services/messages-modal.service';
import { User } from '../../../../interfaces/user.interface';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs/operators';
import { LessonCard } from 'src/app/interfaces/lesson-card.interface';
import { plananualchilepb } from 'src/app/mocks/plananual-chile-pb';
import { plananualchileb } from 'src/app/mocks/plananual-chile-b';

@Component({
  selector: 'app-activity-card',
  templateUrl: './activity-card.component.html',
  styleUrls: ['./activity-card.component.css'],
})
export class ActivityCardComponent implements OnInit {
  scaleCard: string;
  cardSizeScaled: number;

  canEdit: boolean;
  canDelete: boolean;
  showDots: boolean;

  act2copy: string;

  @Input() cardSize: number;
  @Input() activityCardInfo: ActivityCard;
  @Output('reload') deleteActivity: EventEmitter<any> = new EventEmitter();

  user: User;

  constructor(
    private translate: TranslateService,
    private api: ApiV2Service,
    private router: Router,
    private spinner: SpinnerService,
    public auth: AuthService,
    private message: MessagesModalService
  ) {
    this.user = auth.currentUser;
  }

  ngOnInit(): void {
    // this.scaleCard.subscribe(()=>{});
    if (
      this.auth.currentUser.isOrgAdmin ||
      this.auth.currentUser.isSuperuser ||
      (this.auth.currentMainOrganization.organizationType === 'Familia' &&
        this.activityCardInfo.owner.id === this.auth.currentUser.id) ||
      (this.auth.currentMainOrganization.organizationType === 'Escuela' &&
        this.activityCardInfo.owner.id === this.auth.currentUser.id)
    ) {
      this.canEdit = true;
      this.canDelete = true;
    } else {
      this.canEdit = true;
      this.canDelete = true;
    }
    //console.log(this.activityCardInfo.id)
    if (
      localStorage.getItem('level1') == 'pb' ||
      localStorage.getItem('level1') == 'b'
    ) {
      if (
        plananualchilepb.some((item) => {
          return this.activityCardInfo.id == item.id.toString();
        }) &&
        localStorage.getItem('level1') == 'pb'
      ) {
        console.log('entro aca 1');
        this.showDots = false;
      } else if (
        plananualchileb.some((item) => {
          return this.activityCardInfo.id == item.id.toString();
        }) &&
        localStorage.getItem('level1') == 'b'
      ) {
        console.log('entro aca 2');
        this.showDots = false;
      } else {
        //console.log(this.activityCardInfo.id,'no entro aca 1')
        this.showDots = true;
      }
    } else {
      this.showDots = false;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    this.scaleCard = `scale(${this.cardSize / 240})`;
    this.cardSizeScaled = this.cardSize / (this.cardSize / 240);
  }

  setSceneLength(scenes: Scene[]) {
    if (scenes) {
      return scenes.length <= 0
        ? ''
        : scenes.length === 1
        ? `1 escena`
        : `${scenes.length} escenas`;
    } else {
      return '';
    }
  }

  onEdit() {
    this.router.navigate([
      'lessons/activity-creator',
      this.activityCardInfo.id,
    ]);
  }

  onDeactivate() {
    this.spinner.showSpinner = true;
    const body = { is_active: !this.activityCardInfo.isActive };
    this.api
      .patchAlternativeService('EDIT_ACTIVITY', body, this.activityCardInfo.id)
      .subscribe(
        (lesson) => {
          this.activityCardInfo.isActive = lesson['is_active'];
          console.log(lesson);
          this.spinner.showSpinner = false;
        },
        (error) => {
          console.log(error);
          this.spinner.showSpinner = false;
        }
      );
  }

  onDelete() {
    this.message
      .openDialog(
        'warning',
        this.translate.instant('DIALOGMESSAGEACTIVITY.CARD.DELETETITLE'),
        this.translate.instant('DIALOGMESSAGEACTIVITY.CARD.DELETE')
      )
      .afterClosed()
      .subscribe((result: boolean) => {
        if (result) {
          this.spinner.showSpinner = true;
          this.api
            .deleteAlternativeService(
              'DELETE_ACTIVITY',
              this.activityCardInfo.id
            )
            .subscribe(
              (data) => {
                this.deleteActivity.emit();
                this.spinner.showSpinner = false;
              },
              (error) => {
                console.log(error);
                this.spinner.showSpinner = false;
              }
            );
        }
      });
    this.spinner.showSpinner = false;
  }

  ispublicAct(): boolean {
    if (this.router.url.startsWith('/lessons/public-activities', 0)||this.router.url.startsWith('/lessons/partner-lessons/', 0)) {
      //console.log('url actividades publicas');
      return true;
    } else {
      //console.log('no estas en actividades publicas')
      return false;
    }
  }

  onVisibility() {
    this.spinner.showSpinner = true;
    const body = { is_public: !this.activityCardInfo.isPublic };
    this.api
      .patchAlternativeService(
        'SHOW_HIDE_ACTIVITY',
        body,
        this.activityCardInfo.id
      )
      .subscribe(
        (lesson) => {
          this.activityCardInfo.isPublic = lesson['is_public'];
          this.spinner.showSpinner = false;
        },
        (error) => {
          console.log('Error: ', error);
          this.spinner.showSpinner = false;
        }
      );
  }

  goToInfo() {
    if (this.activityCardInfo.owner.id === this.auth.currentUser.id) {
      this.router.navigate([
        '/lessons/activity-info',
        this.activityCardInfo.id,
      ]);
    } else {
      this.router.navigate([
        '/lessons/activity-info',
        this.activityCardInfo.id,
        '/',
      ]);
    }

    //this.router.navigate(['/lessons/activity-info', this.activityCardInfo.id,true]);
  }

  copyToMy() {
    this.message
      .openDialog(
        'question',
        this.translate.instant('DIALOGMESSAGEACTIVITY.CARD.COPYTITLE'),
        this.translate.instant('DIALOGMESSAGEACTIVITY.CARD.COPYMSG')
      )
      .afterClosed()
      .subscribe((result: boolean) => {
        console.log(result);
        if (result) {
          this.copyActivity(this.auth.currentUser.email);
        }
      });
  }

  addToGrade() {
    this.message
      .openActivityGradeDialog(
        'info',
        this.translate.instant('DIALOGMESSAGEACTIVITY.CARD.ADDTOGRADEMSG0'),
        this.activityCardInfo.id.toString()
      )
      .afterClosed()
      .subscribe((result: any[]) => {
        console.log(result);
        const body = { grades: result };
        console.log(body);
        this.api
          .postAlternativeService(
            'ACTIVITIES_TO_GRADE',
            body,
            this.activityCardInfo.id
          )
          .subscribe(
            (result: any) => {
              //console.log(result); hacer un if si esta creando una asignatura o no
              this.message
                .openDialog(
                  'success',
                  `${this.translate.instant(
                    'DIALOGMESSAGEACTIVITY.CARD.ADDTOGRADEMSG'
                  )} ${this.activityCardInfo.text} ${this.translate.instant(
                    'DIALOGMESSAGEACTIVITY.CARD.ADDTOGRADEMSG1'
                  )}'`
                )
                .afterClosed()
                .subscribe((result: boolean) => {});
            },
            (error) => {
              console.log('Error: ', error);
              this.spinner.showSpinner = false;
            }
          );
      });
  }

  addToGrade2() {
    if (this.user.id == this.activityCardInfo.owner.id) {
      this.message
        .openActivityGradeDialog(
          'question',
          this.translate.instant('DIALOGMESSAGEACTIVITY.CARD.ADDTOGRADETITLE'),
          this.activityCardInfo.id.toString()
        )
        .afterClosed()
        .subscribe((result: any[]) => {
          console.log(result);
          if (result) {
            const body = { grades: result };
            console.log(body);
            this.api
              .patchAlternativeService(
                'SHOW_HIDE_ACTIVITY',
                body,
                this.activityCardInfo.id
              )
              .subscribe(
                (result: any) => {
                  console.log(result);
                  this.message
                    .openDialog(
                      'success',
                      `${this.translate.instant(
                        'DIALOGMESSAGEACTIVITY.CARD.ADDTOGRADEMSG'
                      )} ${this.activityCardInfo.text} ${this.translate.instant(
                        'DIALOGMESSAGEACTIVITY.CARD.ADDTOGRADEMSG1'
                      )}'`
                    )
                    .afterClosed()
                    .subscribe((result: boolean) => {});
                },
                (error) => {
                  console.log('Error: ', error);
                  this.spinner.showSpinner = false;
                }
              );
          }
        });
    } else {
      console.log('no puedes');
      this.message
        .openDialog(
          'warning',
          `${this.translate.instant(
            'DIALOGMESSAGEACTIVITY.CARD.ADDTOGRADEERROR'
          )} ${this.activityCardInfo.owner.email} ${this.translate.instant(
            'DIALOGMESSAGEACTIVITY.CARD.ADDTOGRADEERROR'
          )}`
        )
        .afterClosed()
        .subscribe((result: boolean) => {});
    }
  }

  copyToAnother() {
    this.message
      .openCopyActivityDialog('question', 'Copiar Actividad')
      .afterClosed()
      .subscribe((result: string) => {
        console.log(result);
        if (result) {
          this.copyActivity(result);
        }
      });
  }

  copyActivity(email: string) {
    this.spinner.showSpinner = true;
    const body = {
      user_email: email,
      activity_ids: [this.activityCardInfo.id],
    };
    this.api.postService('COPY_ACTIVITY', body).subscribe(
      (data) => {
        console.log('actividad copiada', data);
        
        this.getActivitiesByParams();
        
        this.message
          .openDialog(
            'success',
            this.translate.instant('DIALOGMESSAGEACTIVITY.CARD.COPYOK')
          )
          .afterClosed()
          .subscribe((result: string) => {
            if (email == this.auth.currentUser.email) {
              this.message
                .openActivityGradeDialog(
                  'info',
                  this.translate.instant(
                    'DIALOGMESSAGEACTIVITY.CARD.ADDTOGRADEMSG0'
                  ),
                  this.act2copy
                )
                .afterClosed()
                .subscribe((result: string) => {
                  console.log(
                    'recibiendo del dialog panel',
                    result,
                    result.length
                  );
                  const body = { grades: result };
                  console.log(body);
                  this.api
                    .postAlternativeService(
                      'ACTIVITIES_TO_GRADE',
                      body,
                      this.act2copy
                    )
                    .subscribe(
                      (result: any) => {
                        console.log(result);
                        this.message
                          .openDialog(
                            'success',
                            `${this.translate.instant(
                              'DIALOGMESSAGEACTIVITY.CARD.ADDTOGRADEMSG'
                            )} ${
                              this.activityCardInfo.text
                            } ${this.translate.instant(
                              'DIALOGMESSAGEACTIVITY.CARD.ADDTOGRADEMSG1'
                            )}'`
                          )
                          .afterClosed()
                          .subscribe((result: boolean) => {});
                      },
                      (error) => {
                        console.log('Error: ', error);
                        this.spinner.showSpinner = false;
                      }
                    );

                  this.spinner.showSpinner = false;
                });
            } else {
              this.spinner.showSpinner = false;
            }
          });
      },
      (error) => {
        if (error.error.errors)
          console.log('Error: ', error.error.errors[0].msg);
        console.log('error status: ', error.status);
        this.spinner.showSpinner = false;

        if (error.status >= 400 && error.status < 500) {
          if (error.error.errors.length > 0) {
            if (error.error.errors[0].msg.includes('has max activities')) {
              this.message.openDialog(
                'danger',
                'Error',
                `${this.translate.instant(
                  'DIALOGMESSAGEACTIVITY.CARD.MAXACTIVITYREACHED'
                )}`
              );
            } else if (
              error.error.errors[0].msg.includes(
                'not all activities have requester organization'
              )
            ) {
              {
                this.message.openDialog(
                  'danger',
                  'Error',
                  `${this.translate.instant(
                    'DIALOGMESSAGEACTIVITY.CARD.UNAUTHORIZEDCOPY'
                  )}`
                );
              }
            } else {
              this.message.openDialog(
                'danger',
                'Error',
                `${this.translate.instant(
                  'DIALOGMESSAGEACTIVITY.CARD.UNAUTHORIZEDCOPY'
                )}`
              );
            }
          } else {
            this.message.openDialog(
              'danger',
              'Error',
              `${this.translate.instant(
                'DIALOGMESSAGEACTIVITY.CARD.UNAUTHORIZEDCOPY'
              )}`
            );
          }
        } else if (error.status >= 500 && error.status < 600) {
          this.message.openDialog(
            'danger',
            'Ups... ',
            `ERROR ${error.status}: ${this.translate.instant(
              'DIALOGMESSAGEACTIVITY.CARD.UNAUTHORIZEDCOPY'
            )}`
          );
        }
      }
    );
  }

  sameOrganization() {
    console.log(this.activityCardInfo.owner.organizations[0].id);
    var boool = false;
    var anyy = this.activityCardInfo.owner.organizations.map((item) => {
      return item.id;
    });
    if (anyy.includes(this.auth.currentMainOrganization.id)) {
      return true;
    } else return false;
    console.log(anyy.includes(this.auth.currentMainOrganization.id));

    //   this.activityCardInfo.owner.organizations.map((item)=>{
    //     if(!boool){
    //     if(item.id==this.auth.currentMainOrganization.id){
    //     console.log
    //       boool=true;
    //       return true}
    //   }
    //   else {return false}});
  }

  ownActivities(): boolean {
    if (
      this.router.url.startsWith('/lessons/activities', 0) ||
      this.activityCardInfo.owner['id'] == this.auth.currentUser.id
    ) {
      //console.log('own');
      return true;
    } else {
      //console.log(' no own')
      return false;
    }
  }

  getActivitiesByParams(params?: any) {
    this.spinner.showSpinner = true;
    params = {
      limit: 3,
    };
    this.api
      .getService('GET_ACTIVITIES_BY_OWNER', params)
      .pipe(
        map((data) => {
          for (const key in data['results']) {
            if (data['results'].hasOwnProperty(key)) {
              data['results'][key]['color'] = '#EF7D00';
              data['results'][key]['isActive'] =
                data['results'][key]['is_active'];
              data['results'][key]['isPublic'] =
                data['results'][key]['is_public'];
              data['results'][key]['isInstalled'] =
                data['results'][key]['is_installed'];
              delete data['results'][key]['is_Active'];
              delete data['results'][key]['is_public'];
              delete data['results'][key]['is_installed'];
            }
            if (data['results'][key]['owner']['organizations']) {
              for (const keyB in data['results'][key]['owner'][
                'organizations'
              ]) {
                if (
                  data['results'][key]['owner']['organizations'].hasOwnProperty(
                    keyB
                  )
                ) {
                  data['results'][key]['owner']['organizations'][keyB][
                    'organizationType'
                  ] =
                    data['results'][key]['owner']['organizations'][keyB][
                      'organization_type'
                    ];
                  delete data['results'][key]['owner']['organizations'][keyB][
                    'organization_type'
                  ];
                }
              }
            }
          }

          return data['results'];
        })
      )
      .subscribe(
        (activities: ActivityCard[] | any[]) => {
          console.log(activities[0].id);
          this.act2copy=activities[0].id;
          //this.activityCardInfo = activities[0];
        },
        (error) => {
          console.log('Error:', error);
          this.spinner.showSpinner = false;
        }
      );
  }

  addGrade(grades: any[]) {
    /*  this.spinner.showSpinner = true;
     const body = {
       //user_email: email,
       activity_ids: [this.activityCardInfo.id]
     };
     this.api.postService('COPY_ACTIVITY', body).subscribe(
       (data) => {
         console.log(data)
         this.message.openDialog('success', 'Se copió la actividad al usuario'),
           this.spinner.showSpinner = false
       },
       (error) => {
         console.log('Error: ', error);
         this.spinner.showSpinner = false;
         if (error.status >= 400 && error.status < 500) {
           this.message.openDialog('danger', 'Error al guardar',
             `ERROR ${error.status}: Parece que los datos en el formulario están incompletos,
                       son incorrectos o no estás autorizado para editar esta asignatura. Revisa y reintenta`)
         } else if (error.status >= 500 && error.status < 600) {
           this.message.openDialog('danger', 'Ups... ',
             `ERROR ${error.status}: Parece que algo no está funcionando bien en la casa de SIMA, reintenta de nuevo luego.`)
         }
       }
     ); */
  }

  checkLibrary() {
    //console.log(this.showDots, this.activityCardInfo.id, 'check library');
    if (
      this.router.url.startsWith('/lessons/public-activities', 0) &&
      (this.activityCardInfo.owner['id'] === 36212 ||
        this.activityCardInfo.owner['id'] === 39710 ||
        this.activityCardInfo.owner['id'] === 14796 ||
        this.activityCardInfo.owner['id'] === 9693 ||
        this.showDots)
    ) {
      //console.log(this.activityCardInfo.id,'fue positivo el check library')
      this.canEdit = false;
      this.canDelete = false;
      //console.log(this.canDelete, this.canEdit);
      return true;
    } else return false;
  }
}
